import { connect } from 'react-redux'
import { Auth0Provider } from '../components/Auth0Provider'
import { changedAuthState, createdAuth0Client } from '../actions'
import * as api from '../../../actions/api'
import { makePath } from '../../../lib'

const mapStateToProps = (state, ownProps) => {
  const { language } = state.user

  return ({
    language
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    createdAuth0Client: (auth0) => {
      dispatch(createdAuth0Client(auth0))
    },
    changedAuthState: (user, language, history) => {
      dispatch(changedAuthState(user))
      if (user) {
        dispatch(api.user.settings((dispatch, response) => {
          if (response.result === true && (response.settings === undefined || response.settings.userName === undefined)) {
            history.push(makePath('/signup', language))
          }
        }))
      }
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Auth0Provider)


// WEBPACK FOOTER //
// ./src/Parts/Auth0/containers/Auth0Provider.js